export default "__VITE_ASSET__4d83bab1__"